import type { Column } from './types.js';

const NON_PIN_START_KEYS = new Set(['act', '__actions']);

export function resolveEffectivePinStartColumnKey<T>(
  columns: Column<T>[],
  pinStartColumnKey?: string,
  mobileTableScroll = false,
): string | undefined {
  if (pinStartColumnKey) return pinStartColumnKey;
  if (!mobileTableScroll) return undefined;
  return columns.find((c) => !NON_PIN_START_KEYS.has(c.key))?.key;
}

export function resolveColumnsWithPin<T>(
  columns: Column<T>[],
  pinStartColumnKey?: string,
  pinEndColumns = true,
): Column<T>[] {
  return columns.map((c) => {
    if (c.sticky) return c;
    if (pinStartColumnKey && c.key === pinStartColumnKey) return { ...c, sticky: 'start' as const };
    if (pinEndColumns && c.key === 'act') return { ...c, sticky: 'end' as const };
    return c;
  });
}

export function hasStickyHorizontalScroll<T>(
  columns: Column<T>[],
  hasActionColumn: boolean,
  noHorizontalScroll: boolean,
  mobileTableScroll = false,
) {
  if (noHorizontalScroll) return false;
  if (mobileTableScroll) return true;
  return columns.some((c) => c.sticky === 'start' || c.sticky === 'end') || hasActionColumn;
}

export function columnHeaderAriaLabel<T>(column: Column<T>): string {
  if (typeof column.label === 'string' && column.label.trim()) return column.label.trim();
  if (column.headerAriaLabel?.trim()) return column.headerAriaLabel.trim();
  return column.key;
}

export function columnHeaderHasLabel<T>(column: Column<T>): boolean {
  const L = column.label;
  if (L == null || L === false) return false;
  if (typeof L === 'string') return L.trim().length > 0;
  return true;
}
